import { Model } from 'pinia-orm'

import { Attr, BelongsTo, HasMany, Num, Uid } from 'pinia-orm/dist/decorators'
import { Device } from 'modules/Device/Device'
import { Tenant } from 'modules/Tenant/Tenant'
import { Org } from 'modules/Org/Org'

export class DeviceModel extends Model {
  static override entity = 'device_models'

  @Uid() declare id: string
  @Num(null) declare int_id: number | null

  @Attr(null) declare name: string | null
  @Attr(null) declare model_number: number
  @Attr(null) declare reference: string | null
  @Attr(null) declare description: string | null
  @Attr(null) declare board: string | null
  @Attr(null) declare firmware: string | null
  @Attr(null) declare enclosure_type: string | null
  @Attr(null) declare status: string | null
  @Attr(null) declare is_active: boolean
  @Attr(null) declare notes: string | null
  @Attr(null) declare device_model: string | null

  @HasMany(() => Device, 'device_id') declare devices: Device[]

  @Attr(null) declare tenant_id: string
  // @Attr(null) declare org_id: number
  @BelongsTo(() => Tenant, 'tenant_id') declare tenant: Tenant | null
  // @BelongsTo(() => Org, 'org_id') declare org: Org | null
}
